import http from '@/http';

const RECENTLY_VIEWED_RECEIVED = 'RECENTLY_VIEWED_RECEIVED';

const state = {
  items: []
};

const getters = {
  getRecentlyViewedItems(state) {
    return state.items
  }
}

const actions = {
  async getRecentlyViewed({commit, rootState}) {
    try {
      if (rootState.user.accessPrivileges.indexOf('RECENTLY_VISITED') >= 0) {
        const width = window.innerWidth;
        const limit = width > 1024 ? 12 : width > 769 && width < 1024 ? 8 : 6; // eslint-disable-line

        const {data} = await http.get(`recent/viewed?limit=${limit}`);
        commit(RECENTLY_VIEWED_RECEIVED, {items: data.items});
      } else {
        commit(RECENTLY_VIEWED_RECEIVED, {items: []});
      }
    } catch (err) {
      // na
    }
  }
};

const mutations = {
  [RECENTLY_VIEWED_RECEIVED](state, {items}) {
    state.items = items;
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
